import type React from 'react';

export const getDataFromForm = <T>(event: React.ChangeEvent<HTMLFormElement> | React.SubmitEvent<HTMLFormElement>): T =>
    Object.fromEntries(new FormData(event.currentTarget)) as unknown as T;
